import { render, staticRenderFns } from "./UploadTitulos.vue?vue&type=template&id=2b76747a"
import script from "./UploadTitulos.vue?vue&type=script&lang=js"
export * from "./UploadTitulos.vue?vue&type=script&lang=js"
import style0 from "./UploadTitulos.vue?vue&type=style&index=0&id=2b76747a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports